import { Fragment, useMemo } from 'react';
import YettelB2BLogo from '../../assets/yettel_logo_b2b.svg';
import YettelB2CLogo from '../../assets/yettel_logo_b2c.svg';
import { Button } from '../button/Button';
import { Language } from '../context';

export interface HeaderMenuItem {
  label: string;
  onClick: () => void;
  $selected?: boolean;
}

export interface HeaderProps {
  mode: 'b2c' | 'b2b';
  menuItems: Array<HeaderMenuItem>;
  language: Language;
  onLanguageClick: () => void;
}

export const Header = ({ mode, menuItems, language, onLanguageClick }: HeaderProps) => {
  const cssClass = useMemo(() => {
    if (mode === 'b2b') {
      return 'b2b';
    }
    return 'b2c';
  }, [mode]);

  const displayedLanguage = useMemo(() => {
    if (language === 'en') {
      return 'hu';
    }
    return 'en';
  }, [language]);
  // console.log(cssClass);
  return (
    <>
      <input
        id="menuSwitch"
        className="header__switch"
        type="checkbox"
        aria-label={language === 'hu' ? 'Menü megnyitása' : 'Open menu'}
      />
      <header
        className={`header header--${cssClass}`}
        role="banner"
      >
        <div
          className="header__logo"
          aria-label="Yettel logo"
          role="img"
        >
          {mode === 'b2c' ? <YettelB2CLogo /> : <YettelB2BLogo />}
        </div>
        <nav
          className="header__menu-items"
          role="navigation"
          aria-label={language === 'hu' ? 'Menü' : 'Menu'}
        >
          <ul role="menubar">
            {(menuItems || []).map((menuItem, index) => (
              <Fragment key={index}>
                <li
                  onClick={menuItem.onClick}
                  onKeyUp={e => {
                    if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.key === ' ') {
                      menuItem.onClick();
                    }
                  }}
                  className={`header__menu-item ${menuItem.$selected ? `header__menu-item--${cssClass}--selected` : `header__menu-item--${cssClass}`}`}
                  role="menuitem"
                  tabIndex={0}
                  aria-current={menuItem.$selected ? 'page' : undefined}
                  aria-label={menuItem.label}
                >
                  {menuItem.label}
                </li>
              </Fragment>
            ))}
          </ul>
        </nav>
        <div className="header__fill"></div>
        <div className="header__switch-language">
          <Button
            className={`button--${cssClass}`}
            variant={'text'}
            onClick={onLanguageClick}
            aria-label={
              language === 'hu'
                ? `Nyelv váltása: ${displayedLanguage.toUpperCase()}`
                : `Switch language to ${displayedLanguage.toUpperCase()}`
            }
          >
            {displayedLanguage.toUpperCase()}
          </Button>
        </div>
        <div className="header__mobile-toggle">
          <label
            htmlFor="menuSwitch"
            aria-label={language === 'hu' ? 'Menü' : 'Menu'}
          >
            <span className={`ham ham--${cssClass}--1`} />
            <span className={`ham ham--${cssClass}--2`} />
            <span className={`ham ham--${cssClass}--3`} />
          </label>
        </div>
      </header>
    </>
  );
};
